<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3>{{ 'ORDERS.FILTER_CTA' | translate }}</h3>
    <form
      [formGroup]="orders_filters_from_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.ORDER_ID_COLUMN_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="order_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.COMPANY_ID_COLUMN_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="company_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.USER_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="buyer_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'GENERAL.PHONE_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="phone_number"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'GENERAL.STORE_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="store_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'GENERAL.OWNER_LINK_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="owner_link"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> Qinetic ID </mat-label>
        <input
          matInput
          type="text"
          formControlName="qinetic_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.HAS_QINETIC_ID_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="has_qinetic_id"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="yes">
            {{ 'GENERAL.YES_LABEL' | translate }}
          </mat-option>
          <mat-option [value]="no">
            {{ 'GENERAL.NO_LABEL' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.QINETIC_BUG_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="qinetic_bug"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="yes">
            {{ 'GENERAL.YES_LABEL' | translate }}
          </mat-option>
          <mat-option [value]="no">
            {{ 'GENERAL.NO_LABEL' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.EXT_ORDER_ID_LABEL' | translate }} </mat-label>
        <input
          matInput
          type="text"
          formControlName="external_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="status"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="archived_status">
            {{ getOrderStatusLabel(archived_status) | translate }}
          </mat-option>
          <mat-option [value]="running_status">
            {{ getOrderStatusLabel(running_status) | translate }}
          </mat-option>
          <mat-option [value]="pending_status">
            {{ getOrderStatusLabel(pending_status) | translate }}
          </mat-option>
          <mat-option [value]="store_review_status">
            {{ getOrderStatusLabel(store_review_status) | translate }}
          </mat-option>
          <mat-option [value]="canceled_status">
            {{ getOrderStatusLabel(canceled_status) | translate }}
          </mat-option>
          <mat-option [value]="refunded_status">
            {{ getOrderStatusLabel(refunded_status) | translate }}
          </mat-option>
          <mat-option [value]="completed_status">
            {{ getOrderStatusLabel(completed_status) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.CHANNEL_COLUMN_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="channel"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="off_session_channel">
            {{ getChannelLabel(off_session_channel) | translate }}
          </mat-option>
          <mat-option [value]="on_session_channel">
            {{ getChannelLabel(on_session_channel) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.ORIGIN_COLUMN_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="origin"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="web_origin">
            {{ getOriginLabel(web_origin) | translate }}
          </mat-option>
          <mat-option [value]="in_store_origin">
            {{ getOriginLabel(in_store_origin) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.APPROVED_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="approved"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="yes">
            {{ 'GENERAL.YES_LABEL' | translate }}
          </mat-option>
          <mat-option [value]="no">
            {{ 'GENERAL.NO_LABEL' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.TAX_DEDUCTION_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="tax_deduction"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="yes">
            {{ 'GENERAL.YES_LABEL' | translate }}
          </mat-option>
          <mat-option [value]="no">
            {{ 'GENERAL.NO_LABEL' | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'COMPANIES.TAX_DEDUCTION_TYPE_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="tax_deduction_type"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="bonus_mobili">
            {{ getTaxDeductionLabel(bonus_mobili) | translate }}
          </mat-option>
          <mat-option [value]="conto_termico">
            {{ getTaxDeductionLabel(conto_termico) | translate }}
          </mat-option>
          <mat-option [value]="conto_termico_3">
            {{ getTaxDeductionLabel(conto_termico_3) | translate }}
          </mat-option>
          <mat-option [value]="interventi_sismici">
            {{ getTaxDeductionLabel(interventi_sismici) | translate }}
          </mat-option>
          <mat-option [value]="riqualifica_edilizia">
            {{ getTaxDeductionLabel(riqualifica_edilizia) | translate }}
          </mat-option>
          <mat-option [value]="risparmio_energetico">
            {{ getTaxDeductionLabel(risparmio_energetico) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.MERCHANT_REFUND_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="merchant_refund"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="vban_succeeded_status">
            {{ getVbanStatusLabel(vban_succeeded_status) | translate }}
          </mat-option>
          <mat-option [value]="vban_pending_status">
            {{ getVbanStatusLabel(vban_pending_status) | translate }}
          </mat-option>
          <mat-option [value]="vban_partially_funded_status">
            {{ getVbanStatusLabel(vban_partially_funded_status) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.BD1' | translate }} </mat-label>
        <mat-select
          formControlName="bd1"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="'del-pos'">
            {{ getBDLabel(del_pos) | translate }}
          </mat-option>
          <mat-option [value]="'del-neg'">
            {{ getBDLabel(del_neg) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.BD2' | translate }} </mat-label>
        <mat-select
          formControlName="bd2"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="'del-pos'">
            {{ getBDLabel(del_pos) | translate }}
          </mat-option>
          <mat-option [value]="'del-neg'">
            {{ getBDLabel(del_neg) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.BD5' | translate }} </mat-label>
        <mat-select
          formControlName="bd5"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="'del-pos'">
            {{ getBDLabel(del_pos) | translate }}
          </mat-option>
          <mat-option [value]="'del-neg'">
            {{ getBDLabel(del_neg) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.LIQUIDATION_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="liquidation"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="liquidation_ok"> OK </mat-option>
          <mat-option [value]="liquidation_ko"> KO </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.FILTER_CREATED_FROM_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="created_from"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="created_from_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="created_from_picker"></mat-datepicker-toggle>
        <mat-datepicker #created_from_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.FILTER_CREATED_TO_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="created_to"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="created_to_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="created_to_picker"></mat-datepicker-toggle>
        <mat-datepicker #created_to_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.FILTER_COMPLETED_FROM_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="completed_from"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="completed_from_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="completed_from_picker"></mat-datepicker-toggle>
        <mat-datepicker #completed_from_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.FILTER_COMPLETED_TO_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="completed_to"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="completed_to_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="completed_to_picker"></mat-datepicker-toggle>
        <mat-datepicker #completed_to_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label> {{ 'ORDERS.LAST_OPERATION_LABEL' | translate }} </mat-label>
        <mat-select
          formControlName="last_operation"
          [errorStateMatcher]="error_matcher">
          <mat-option
            *ngFor="let last_order_status of this.lastOrderStatusOptions"
            [value]="last_order_status.value">
            {{ last_order_status.label | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.FILTER_LAST_OPERATION_FROM_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="last_operation_from"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="last_operation_from_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="last_operation_from_picker"></mat-datepicker-toggle>
        <mat-datepicker #last_operation_from_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__half sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.FILTER_LAST_OPERATION_TO_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="last_operation_to"
          [errorStateMatcher]="error_matcher"
          [matDatepicker]="last_operation_to_picker" />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="last_operation_to_picker"></mat-datepicker-toggle>
        <mat-datepicker #last_operation_to_picker></mat-datepicker>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.AGREEMENT_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="agreement"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <div class="sp-row__end sp-width__full sp-margin__top">
        <p
          (click)="onClearFiltersClick()"
          class="p-color__accent sp-text__right sp-text__hover">
          {{ 'GENERAL.CLEAR_FILTERS_CTA' | translate }}
        </p>
      </div>

      <div class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'GENERAL.APPLY_FILTERS_CTA'"
          [is_disabled]="!isFormValid()"
          (button_click)="onApplyFiltersClick()"></app-shared-button>
      </div>
    </form>
  </div>
</div>
